<h2 mat-dialog-title>{{ data.title | translate }}</h2>
<mat-label>{{ data.text | translate }}</mat-label>
<mat-dialog-content class="mat-typography">
  <form class="form-wrapper" [formGroup]="ferienAuswertungForm" autocomplete=off>

    <mat-form-field appearance="outline" color="accent">
      <mat-label>{{ 'pages.auswertungen.auswertungDialog.jahr' | translate }}</mat-label>
      <input
        matInput
        [placeholder]="'pages.auswertungen.auswertungDialog.jahr' | translate"
        formControlName="jahr"
      />
    </mat-form-field>

    <mat-form-field class="shortField" appearance="outline">
      <mat-label>{{ 'pages.projektverwaltung.projektDialog.mitarbeiter' | translate }}</mat-label>
      <mat-select #mySel formControlName="mitarbeiter" multiple>
        <mat-option (click)="toggleAllSelection()" [value]="0">Alle</mat-option>
        <mat-option *ngFor="let mitarbeiter of ($mitarbeiter |async)" [value]="mitarbeiter.id" >
          {{mitarbeiter.name + " " + mitarbeiter.vorname + "  " + mitarbeiter.plz + " "  + mitarbeiter.ort }}
        </mat-option>
        <div class="row no-gutters pb-1 buttonPlacement">
          <button
            mat-raised-button
            color="accent"
            (click)="okClicked()"
          >
            Ok
          </button>
        </div>
      </mat-select>
    </mat-form-field>

  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button
    id="abbruch"
    color="none"
    (click)="handleCancelClick()"
    [tabIndex]="-1"
  >
    Abbrechen
  </button>
  <button
    [disableRipple]="true"
    mat-raised-button
    color="accent"
    (click)="okHandleClick()"
  >
    Ok
  </button>
</mat-dialog-actions>
